<template>
    <div class="auction_land_fields pt-3 pb-3">
        
        <b-container fluid v-if="draw_pull_head.length > 0">
            <h1 class="title text-center pt-5 pb-5 mt-5">
                Інформація про лот
            </h1>
            <div class="main_info">
                <b-row class="doc_title mt-4" :key="field.id" v-for="field in this.draw_pull_head">
                    <b-col sm="3">
                        <label class="fs-xl" :for="field.field_type + field.id">{{field.field_name}} </label>
                    </b-col>
                    <b-col sm="9">
                        <div class="edit_text" @click="edit_field(field)" v-if="field.field_type == 'total_lot_cost'">
                            <fa :icon="faEdit"/>
                        </div>
                        
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="field.field_val_to_show"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
                
                <b-row class="doc_title mt-4" key="square_cost" v-if="square_cost > 0">
                    <b-col sm="3">
                        <label class="fs-xl" for="square_cost">Вартість 1 Га, грн</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="new Intl.NumberFormat().format(square_cost)"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
                
                <b-row class="doc_title mt-4" key="op_year" v-if="op_years > 0">
                    <b-col sm="3">
                        <label class="fs-xl" for="op_in_year">Окупність лота в роках</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="op_years"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
                
                <b-row class="doc_title mt-4" key="op_in_year" v-if="op_year_ga > 0">
                    <b-col sm="3">
                        <label class="fs-xl" for="op_in_year">Актуальна сума ОП в рік на 1 Га, чистими на руки</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="new Intl.NumberFormat().format(op_year_ga)"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
                
                <b-row class="doc_title mt-4" key="op_perc_year" v-if="op_percent_year > 0">
                    <b-col sm="3">
                        <label class="fs-xl" for="op_perc_year">Доходність ЗД в рік, %</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="op_percent_year"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
            </div>
        </b-container>
        
        <b-container class="mb-2" fluid v-if="draw_isp_field.length > 0">
            <h1 class="title text-center pt-5 pb-5 mt-5">
                Реквізити по оформленню документів
            </h1>
            <div class="main_info">
                <b-row class="doc_title mt-4" :key="field.id" v-for="field in this.draw_isp_field">
                    <b-col sm="3">
                        <label class="fs-xl" :for="field.type + field.id">{{field.name}} </label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            :disabled="true"
                            v-model="field.value"
                            size="sm" >
                        </b-form-input>
                    </b-col>
                </b-row>
            </div>
        </b-container>
        
        <b-tabs content-class="mt-3">
            <b-tab
                active-nav-item-class="font-weight-bold text-uppercase text-danger"
                v-for="(tab,index) in this.draw_pull_items" @click="set_pull_active(tab)" :key="index" :active="tab.is_active">
                <template slot="title">
                    <div class='icon-stack fs-xxl'>
                        <i class="base base-7 icon-stack-2x opacity-100 color-primary-500"></i>
                        <i class="fal fa-globe-americas icon-stack-1x opacity-100 color-white"></i>
                    </div>
                    {{get_tab_pull_title(index)}}
                    <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                </template>
                
                <pai_tab
                    :owner="owner_str"
                    :pai_item="tab" :id="'pull_info' + index">
                </pai_tab>
            </b-tab>
        </b-tabs>
    
    </div>
</template>

<script>

import pai_tab from "./tabs/pai_tab.vue";

import Fa from 'vue-fa'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "mem_inside_tab",
    components: {pai_tab,Fa},
    data() {
        return {
            loading_unit: false,
            faEdit
        }
    },
    
    props: {
        
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    
    created() {
    
    },
    methods : {
        
        async edit_field(field) {
            if(parseInt(this.mem.id) > 0) {
                IMC_CORE.showloading();
                
                await api.get('/memorandums/'+ this.mem.id +'/land/rights').then(({data}) => {
                   if (data.status === "operation_success") {
                        let res = data.data;
                        IMC_CORE.hideloading();
                        
                        if(res === 'active' || res === 'active vip_user') {
                            EventBus.$emit('load_editor',{
                                'message': field.field_val,
                                'uniq' : 'land_price|' +this.mem.id,
                            });
                        }
                        
                        else {
                            EventBus.$emit('show_toast', {err: 'Не можливо редагувати!', type: "danger", title: 'Редагування заблоковано'})
                        }
                    }
                }).catch(err => {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
                
            }
            else {
                EventBus.$emit('show_toast', {err: 'Не можливо редагувати!', type: "danger", title: 'Редагування заблоковано'})
            }
            
        },
        
        set_pull_active(tab) {
            tab.is_active = true;
            this.draw_pull_items.map(itm => {
                itm.is_active = false;
            })
        },
        
        get_tab_pull_title(idx) {
            let cur_idx = idx + 1;
            return "Пай " + cur_idx;
        },
    },
    
    computed : {
        
        addon_fields() {
            return this.addon_data;
        },
        
        
        draw_pull () {
            if(this.addon_fields.hasOwnProperty("pull_pai")) {
                return this.addon_fields.pull_pai;
            }
            return {
                "fields" : [],
                "items" : [],
                'isp_fields' : [],
            };
        },
        
        draw_isp_field() {
            return this.draw_pull.isp_fields;
        },
        
        draw_pull_head () {
            this.draw_pull.fields.map(field => {
                if(field.field_type === 'total_lot_cost'){
                    field.field_val_to_show = new Intl.NumberFormat().format(parseFloat(field.field_val.replace(",",".")))
                }
                else {
                    field.field_val_to_show = field.field_val;
                }
            })
            
            return this.draw_pull.fields.filter(item => {
                return !(item.field_type == 'land_adjust' || item.field_type == 'land_worker');
            });
        },
        
        owner_str () {
            let res = '';
            
            try {
                this.draw_pull_head.map(itm => {
                    if(itm.field_type == 'kontragent') {
                        res = itm.field_val;
                    }
                })
            }
            catch (e) {
            
            }
            
            return res;
        },
        
        draw_pull_items () {
            return this.draw_pull.items;
        },
        
        draw_fields ()  {
            if(this.addon_fields.hasOwnProperty("fields")) {
                return this.addon_fields.fields;
            }
            return [];
        },
        
        op_percent_year() {
            let res = 0;
            if(this.op_pais > 0 && this.pull_cost > 0) {
                res = ((this.op_pais * 0.77) / this.pull_cost) * 100
            }
            
            return parseFloat(res.toFixed(2))
        },
        
        op_year_ga() {
            let res = 0;
            if(this.op_pais > 0 && this.square_pais > 0) {
                res = (this.op_pais * 0.77) / this.square_pais
            }
            
            return parseFloat(res.toFixed(2))
        },
        
        op_years() {
            let res = 0;
            if(this.pull_cost > 0 && this.op_pais > 0) {
                res = this.pull_cost / (this.op_pais * 0.77);
            }
            
            return parseFloat(res.toFixed(2))
        },
        
        pull_cost() {
            let cost = 0;
            this.draw_pull_head.map(itm => {
                if(itm.field_type == 'total_lot_cost') {
                    cost = parseInt(itm.field_val);
                }
            })
            
            return cost;
        },
        
        square_cost() {
            let res = 0;
            if(this.pull_cost > 0 && this.square_pais > 0) {
                res = this.pull_cost / this.square_pais;
            }
            return parseFloat(res.toFixed(0))
        },
        
        square_pais() {
            try {
                let op = 0;
                this.draw_pull_items.map(pull => {
                    pull.fields.map(field => {
                        if(field.field_type === 'square'){
                            op += parseFloat(field.field_val.replace(",","."))
                        }
                    })
                })
                return op;
            }
            catch (e) {
                console.log(e);
            }
        },
        
        total_lot_cost() {
        
        },
        
        op_pais() {
            try {
                let op = 0;
                this.draw_pull_items.map(pull => {
                    pull.fields.map(field => {
                        if(field.field_type === 'doz_sum'){
                            op += parseInt(field.field_val)
                        }
                    })
                })
                return op;
            }
            catch (e) {
                console.log(e);
            }
        }
        
    }
    
    
}

</script>

<style scoped>
.edit_text {
    position: absolute;
    right: 14px;
    top: 7px;
    cursor: pointer;
}
</style>
